const Locate = {
  'header.title': 'Rezervácia termínu',

  'search_expert.title': 'Vyhľadajte lekára / špecializáciu',

  'buttons.back': 'Späť',
  'buttons.continue': 'Pokračovať',
  'buttons.send': 'Odoslať',
  'buttons.confirm': 'Overiť',

  'eVisits.freeText': 'ambulancia',
  'eVisits.premiumText': 'e-Termín Premium',
};

export default Locate;
